import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import ImageOne from "./images/1.webp";
import ImageTwo from "./images/2.webp";
import ImageThree from "./images/3.webp";
import ImageFour from "./images/4.webp";
import ImageFive from "./images/5.webp";
import ImageSix from "./images/6.webp";
import ImageSeven from "./images/7.webp";
import ImageEight from "./images/8.webp";
import ImageNine from "./images/9.webp";
import ImageTen from "./images/10.webp";
import ImageEleven from "./images/11.webp";
import ImageTwelve from "./images/12.webp";


function History() {
  return (
    <div className="bg-base">
      <div className="timeline p-top-8 p-bottom-8">
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Еднооо...</span>
              </h2>
              <div>
                <img alt="" src={ImageOne} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Двеее...</span>
              </h2>
              <div>
                <img alt="" src={ImageTwo} className="family-photo"></img>
              </div>
            </div>
            <div className="timeline-circle"></div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Триии...</span>
              </h2>
              <div>
                <img alt="" src={ImageThree} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Четириии...</span>
              </h2>
              <div>
                <img alt="" src={ImageFour} className="family-photo"></img>
              </div>  
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Пееет...</span>
              </h2>
              <div>
                <img alt="" src={ImageFive} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Шееест...</span>
              </h2>
              <div>
                <img alt="" src={ImageSix} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Сеедем...</span>
              </h2>
              <div>
                <img alt="" src={ImageSeven} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Ооосем...</span>
              </h2>
              <div>
                <img alt="" src={ImageEight} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Дееевет...</span>
              </h2>
              <div>
                <img alt="" src={ImageNine} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Дееесет....</span>
              </h2>
              <div>
                <img alt="" src={ImageTen} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">Единайййсет....</span>
              </h2>
              <div>
                <img alt="" src={ImageEleven} className="family-photo"></img>
              </div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <span className="text-primary">ДВАНАЙСЕЕЕТ!!!</span>
              </h2>
              <div>
                <img alt="" src={ImageTwelve} className="family-photo"></img>
              </div>
              <p className="m-bottom-1">
                И нека продължим броенето заедно! Потвърдете присъствието си и бъдете с мен на 24 Май, 2025г.!
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default History;
